import React, { useEffect, useMemo, useState } from "react";

import { Button, Checkbox, Modal } from "antd";
import "./index.less";
import { CloseIcon } from "@/assets/img";
import { useTranslation } from "react-i18next";
import { useDebounce } from "@/utils";
import { changeEgovUrl } from "@/utils/tools";
import { lookup } from "mime-types";
import { CheckboxChangeEvent } from "antd/lib/checkbox/Checkbox";
interface OwnProps {
  title: string;
  toolTip?: string;
  visible: boolean;
  isKeyboard?: boolean;
  size?: number;
  isImage?: boolean; // 发送图片modal
  isEgovFile?: boolean; // 是否只能政务外网下载
  showEgovFileCheck?: boolean; // 发送egov文件modal
  isOrigin?: boolean; // 选择原图按钮
  rows?: any;
  fileName?: string;
  onCancel: () => void;
  onClick: () => void;
  onKeyDown?: (e: any) => void;
  onChange?: (e: any) => void;
  children: any;
  footerLine?: boolean;
  okText?: string;
  selfClass?: string;
  disabled?: boolean;
  onEgovFileCheckedChange?: (value: boolean) => void;
}

export default function MyModal({
  title,
  toolTip,
  visible,
  isKeyboard,
  size,
  isImage,
  isOrigin,
  rows,
  fileName,
  onCancel,
  onClick,
  onKeyDown,
  onChange,
  children,
  footerLine = true,
  okText,
  selfClass,
  disabled,
  isEgovFile,
  onEgovFileCheckedChange,
  showEgovFileCheck
}: OwnProps) {
  const [t] = useTranslation("common");
  const [egovFileChecked, setEgovFileChecked] = useState(false);
  useEffect(() => {
    if (!onKeyDown) {
      return;
    }
    if (visible && isKeyboard) {
      document.addEventListener("keydown", onKeyDown);
      return () => {
        document.removeEventListener("keydown", onKeyDown);
      };
    }
  }, [visible, isKeyboard, onKeyDown]);

  const isDefaultOrigin = useMemo(() => {
    if (isImage) {
      if (size) {
        return size < 1024 * 1024 || (lookup(fileName || "") as string) === "image/gif";
      }
      if (rows) {
        const isAllGIF = rows.every((item: any) => item.file.type === "image/gif");
        const isOutofSize = rows.some((item: any) => item.file.size >= 1024 * 1024);
        return !isOutofSize || isAllGIF;
      }
      return false;
    }
  }, [rows, size, isImage, fileName]);

  const handleOk = useDebounce(onClick, 450);

  const handleEgovFileChange = (e: CheckboxChangeEvent) => {
    if (onEgovFileCheckedChange) {
      onEgovFileCheckedChange(e.target.checked);
    }
  };

  function getFooter() {
    return (
      <div
        className={`my-modal-footer ${isImage || showEgovFileCheck ? "my-modal-footer_image" : ""}`}
      >
        {isImage && (
          <div>
            <Checkbox checked={isOrigin} disabled={isDefaultOrigin} onChange={onChange}>
              原图
            </Checkbox>
            <span className="tips">1M以下图片默认以原图发送</span>
          </div>
        )}
        {showEgovFileCheck && (
          <div>
            <Checkbox checked={isEgovFile} onChange={handleEgovFileChange}>
              仅支持政务外网打开
            </Checkbox>
            {/* <span className="tips">1M以下图片默认以原图发送</span> */}
          </div>
        )}
        <div>
          <Button
            // className="my-modal-footer-cancel"
            onClick={onCancel}
          >
            {t("button.cancel")}
          </Button>
          <Button
            // className="my-modal-footer-ok"
            type="primary"
            disabled={!visible || disabled}
            onClick={handleOk}
          >
            {okText || t("button.send")}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <Modal
      className={`my-modal ${selfClass} ${footerLine ? "" : "my-modal-hidden-footerline"}`}
      title={
        <>
          <div className="my-modal-header-title">
            <span>{title}</span>
            {toolTip && <span className="tooltip">{toolTip}</span>}
          </div>
          <span style={{ flex: 1 }} />
          <img
            className="my-modal-header-close"
            src={changeEgovUrl(CloseIcon)}
            onClick={onCancel}
            draggable="false"
          />
        </>
      }
      centered
      visible={visible}
      footer={getFooter()}
      closable={false}
    >
      {children}
    </Modal>
  );
}
